import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";

const width = window.innerWidth;

function RowList(props) {
  return (
    <Stack direction="row-reverse" justifyContent="space-between" alignItems="center">
      <Typography variant="h6"> {props.subject} </Typography>
      <Typography
        sx={{ minWidth: width < 580 ? 50 : 120, fontWeight: "bold" }}
        variant="h6"
      >
        {props.data}
      </Typography>
    </Stack>
  );
}

export default RowList;
